// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import Breadcrumbs from './breadcrumbs'
import connectBreadcrumb from '../redux/connectors/breadcrumb'

export default connectBreadcrumb((props) => (
  <Breadcrumbs {...props} sx={{ variant: 'compounds.breadcrumbs' }} />
))
